import { defineMessages } from 'react-intl';

export const scope = 'app.components.UploadMedia';

export default defineMessages({
  addMedia: {
    id: `${scope}.addMedia`,
    defaultMessage: 'Add media',
  },
  editMedia: {
    id: `${scope}.editMedia`,
    defaultMessage: 'Edit media',
  },
  modal: {
    uploadMessage: {
      id: `${scope}.uploadMessage`,
      defaultMessage:
        "Drag & Drop or <span class='color-blue-6'>browse</span> for files here",
    },
    cancel: {
      id: `${scope}.cancel`,
      defaultMessage: 'Close',
    },
    submit: {
      id: `${scope}.submit`,
      defaultMessage: 'Save',
    },
    labelUpload: {
      id: `${scope}.labelUpload`,
      defaultMessage: 'Upload file',
    },
  },
});
